import Vue from "vue";
import Router from "vue-router";

import Login from "wl-vue-component-login";
// console.log("init router: components: ")
// console.log(Login.components.LoginIndex)
// console.log(Vue.options.components)

import conf from "./conf/webapp.conf";
console.log("router.js ./conf/webapp.conf: ");
console.log(conf);

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "wl-login-login",
      // component: Login,
      component: Login.components.LoginIndex,
      props: {
        modus: "login",
        conf: conf.login,
      },
    },
    {
      path: "/logout",
      name: "wl-login-logout",
      // component: Login,
      component: Login.components.LoginIndex,
      props: { modus: "logout" },
    },
    {
      path: "/reset-login",
      name: "wl-login-resetlogin",
      // component: Login,
      component: Login.components.LoginIndex,
      props: { modus: "resetlogin", conf: conf.login },
    },
  ],
});
